import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { AppIcons } from "../../../../data/appIcons";
import { projectTypeFormData } from "./config/ProjectType.data";
import ToastService from "../../../../services/toastService/ToastService";
import FormCreator from "../../../../components/finalForms/FormCreator";
import Buttons from "../../../../components/ui/button/Buttons";
import { useAddProjectTypeMutation, useLazyGetProjectTypeByIdQuery, useUpdateProjectTypeMutation } from "../../../../app/services/projectTypeAPI";

export const AddEditType = (props) => {

  const [projectTypeForm, setProjectTypeForm] = useState(projectTypeFormData);
  const ProjectTypeRef = useRef();


  const [addProjectType, {
    isSuccess: isProjectTypeAdded,
    isLoading: isProjectTypeAdding,
    data: addProjectTypeData
  },] = useAddProjectTypeMutation();

  const [getProjectTypeById, {
    isFetching: isGetByIdFetching,
    isSuccess: isGetByIdSuccess,
    data: isGetByIdData
  },] = useLazyGetProjectTypeByIdQuery();

  const [UpdateProjectType, {
    isLoading: isProjectTypeUpdating,
    isSuccess: isProjectTypeUpdateSuccess,
    data: isProjectTypeUpdateData
  },] = useUpdateProjectTypeMutation();

  const formReset = () => {
    const projectForm = { ...projectTypeFormData };
    projectForm.initialState = { ...projectTypeFormData.initialState };
    setProjectTypeForm(projectForm);
  };

  useEffect(() => {
    formReset();
    if (props.projectTypeId) {
      getProjectTypeById(props.projectTypeId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getProjectTypeById]);

  useEffect(() => {
    if (isGetByIdSuccess && !isGetByIdFetching && isGetByIdData) {
      if (isGetByIdData) {
        let updatedForm = { ...projectTypeForm };
        updatedForm.initialState = {
          ...updatedForm.initialState,
          projectTypeName: isGetByIdData.projectTypeName,
          isActive: isGetByIdData.isActive,
        };
        setProjectTypeForm(updatedForm);
      }

    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGetByIdSuccess, isGetByIdFetching, isGetByIdData]);


  useEffect(() => {
    if (isProjectTypeAdded && addProjectTypeData) {
      if (addProjectTypeData.errorMessage?.includes("exists")) {
        ToastService.warning(addProjectTypeData.errorMessage);
      } else {
        ToastService.success(addProjectTypeData.errorMessage);
        backToList();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isProjectTypeAdded, addProjectTypeData]);


  useEffect(() => {
    if (isProjectTypeUpdateSuccess && isProjectTypeUpdateData) {
      if (isProjectTypeUpdateData.errorMessage?.includes("exists")) {
        ToastService.warning(isProjectTypeUpdateData.errorMessage);
      } else {
        ToastService.success(isProjectTypeUpdateData.errorMessage);
        backToList();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isProjectTypeUpdateSuccess, isProjectTypeUpdateData]);

  const handleSubmit = () => {
    let ProjectTypeManagementData = ProjectTypeRef.current.getFormData();
    if (!props.projectTypeId && ProjectTypeManagementData) {
      const requestData = {
        ...ProjectTypeManagementData,
        projectTypeName: ProjectTypeManagementData.projectTypeName,
        isActive: ProjectTypeManagementData.isActive || false,
      };
      addProjectType(requestData);
    }
    else if (props.projectTypeId && ProjectTypeManagementData) {
      const requestUpdateData = {
        projectTypeId: props.projectTypeId,
        projectTypeName: ProjectTypeManagementData.projectTypeName,
        isActive: ProjectTypeManagementData.isActive,
      };
      UpdateProjectType(requestUpdateData);
    }
  }

  // Return to List
  const backToList = () => {
    props.onClose();
    formReset();
  };

  return (
    <>
      <FormCreator
        config={projectTypeForm}
        ref={ProjectTypeRef}
      />
      <div className="form-btn d-flex justify-content-end">
        <Buttons
          buttonTypeClassName="dark-btn"
          onClick={backToList}
          buttonText="Cancel"
        />
        <Buttons
          buttonTypeClassName="theme-btn ml-4"
          imagePath={AppIcons.AddIcon}
          buttonText={`${props.projectTypeId ? "Update" : "Add"}`}
          onClick={handleSubmit}
          isLoading={isProjectTypeAdding || isProjectTypeUpdating}
        />
      </div>
    </>
  );

}
AddEditType.propTypes = {
  projectTypeId: PropTypes.number,
  onClose: PropTypes.func,
};

export default AddEditType;